/**
 * Route table owned by the reservation feature.
 *
 * Intentionally NOT added to the shared `Modulor/routes.ts` enum: the feature must stay
 * deletable without touching shared files. The shell only knows about `RESERVATION_ROOT`.
 *
 * One route per *screen* in the design. There is no route for the amount (that is the normal
 * deposit flow) and none for the upload cell's visual states — idle, countdown, error and verified
 * are states of `FileUpload` inside the «Кошти зарезервовано» screen, not separate steps.
 */
export const RESERVATION_ROOT = '/reservation';

/** Absolute paths — use these for navigation. */
export enum ReservationRoutes {
  root = '/reservation',
  kyc = '/reservation/kyc',
  cardProof = '/reservation/card-proof',
  success = '/reservation/success',
  expired = '/reservation/expired',
}

/**
 * Relative paths — use these in `<Route path={...}>` declarations inside the subtree
 * mounted at `/reservation/*`.
 */
export enum ReservationPaths {
  root = '/',
  kyc = 'kyc',
  cardProof = 'card-proof',
  success = 'success',
  expired = 'expired',
}
